 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-de":"lang-de","lang-dk":"lang-dk","lang-es":"lang-es","lang-fr":"lang-fr","lang-no":"lang-no","lang-se":"lang-se"}[chunkId]||chunkId) + "." + {"chunk-12237598":"cc1978f5","chunk-16e988c7":"368fefae","chunk-034615f8":"82c97ff8","chunk-1397aa49":"2aa46390","chunk-03ddfc46":"2bb3911c","chunk-3fb8d048":"b92d0962","chunk-0ea9f7ca":"272812a6","chunk-6d9f3c4e":"9839169d","chunk-957ac556":"541b610b","chunk-2d222d54":"ed282787","chunk-135a9505":"da94f323","chunk-2095165e":"71fe9739","chunk-5c68481d":"9c5cdf90","chunk-038fb254":"48d8e1f6","chunk-045fe954":"42da63a1","chunk-06b1b3b9":"d20739ea","chunk-095f4968":"6049670f","chunk-0aa0fd70":"0bcf030b","chunk-0ae13ccf":"7ed6993f","chunk-100ead2e":"93c5e9c4","chunk-1333226f":"cfc2ce52","chunk-15a62f28":"31ef7fef","chunk-1f6fc138":"aac5f61c","chunk-282b536d":"5590fe16","chunk-36c80a1f":"1204a04e","chunk-3c7b5ce9":"ad30655f","chunk-498486e6":"15029e04","chunk-5303f97e":"46c436de","chunk-552209c0":"5aa27626","chunk-5f4b3ae3":"457a13f4","chunk-61cd75f4":"52a6df50","chunk-682a9cfa":"c9d7ee2e","chunk-6e688752":"b9c0dae7","chunk-74beec90":"ab06e067","chunk-77bb7670":"8201138a","chunk-7d3cf846":"c1eaff97","chunk-abb7f264":"a450f38a","chunk-b4adb4f4":"917c1f3c","chunk-cb5f09ae":"5cb0a0ec","chunk-2d0aa22f":"4f6647f5","chunk-2d0b9be6":"6bc2c4bb","chunk-2d0c02a4":"6b607671","chunk-2d0ab69a":"61fe929a","chunk-2d0ac018":"871747cd","chunk-2d0b366d":"28067c6b","chunk-2d0ced72":"6ceb4d6f","chunk-2d0efd59":"14d4e566","chunk-2d2134cc":"90d96ad2","chunk-2d21e30b":"d2affa0d","chunk-2d21f458":"f79613a5","chunk-50e147be":"79a1f6df","chunk-afa7715a":"71cea9b7","chunk-52f8f587":"9a7c82d3","chunk-3727a89c":"87ae75e4","chunk-2dc50050":"580288c8","chunk-4a5f46a6":"bd0a1b1c","chunk-276585a0":"1cab999a","chunk-05c826c2":"1e968dec","chunk-3b33b664":"472e5f31","chunk-458f0b7f":"2212f4ea","chunk-2d22496f":"e2f7dc97","chunk-2d228fe9":"8f4991eb","chunk-a2f8e1e0":"16700a00","chunk-159ac50e":"80d9dc1d","chunk-2bdd083c":"4ce59604","chunk-4e66891c":"c8c217c0","chunk-765f3329":"fdd82107","chunk-e9a18b28":"a4c2d380","lang-de":"c325c065","lang-dk":"a3e710bf","lang-es":"b3a9d835","lang-fr":"b290fd02","lang-no":"ddcc1e35","lang-se":"c32b5e60"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-12237598":1,"chunk-034615f8":1,"chunk-1397aa49":1,"chunk-03ddfc46":1,"chunk-0ea9f7ca":1,"chunk-6d9f3c4e":1,"chunk-957ac556":1,"chunk-135a9505":1,"chunk-2095165e":1,"chunk-5c68481d":1,"chunk-038fb254":1,"chunk-045fe954":1,"chunk-06b1b3b9":1,"chunk-095f4968":1,"chunk-0aa0fd70":1,"chunk-0ae13ccf":1,"chunk-100ead2e":1,"chunk-1333226f":1,"chunk-15a62f28":1,"chunk-1f6fc138":1,"chunk-282b536d":1,"chunk-36c80a1f":1,"chunk-3c7b5ce9":1,"chunk-498486e6":1,"chunk-5303f97e":1,"chunk-552209c0":1,"chunk-5f4b3ae3":1,"chunk-61cd75f4":1,"chunk-682a9cfa":1,"chunk-6e688752":1,"chunk-74beec90":1,"chunk-77bb7670":1,"chunk-7d3cf846":1,"chunk-abb7f264":1,"chunk-b4adb4f4":1,"chunk-cb5f09ae":1,"chunk-50e147be":1,"chunk-afa7715a":1,"chunk-52f8f587":1,"chunk-3727a89c":1,"chunk-2dc50050":1,"chunk-276585a0":1,"chunk-05c826c2":1,"chunk-3b33b664":1,"chunk-458f0b7f":1,"chunk-a2f8e1e0":1,"chunk-159ac50e":1,"chunk-2bdd083c":1,"chunk-4e66891c":1,"chunk-765f3329":1,"chunk-e9a18b28":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-de":"lang-de","lang-dk":"lang-dk","lang-es":"lang-es","lang-fr":"lang-fr","lang-no":"lang-no","lang-se":"lang-se"}[chunkId]||chunkId) + "." + {"chunk-12237598":"75073713","chunk-16e988c7":"31d6cfe0","chunk-034615f8":"53f66669","chunk-1397aa49":"0b0a830e","chunk-03ddfc46":"56231b24","chunk-3fb8d048":"31d6cfe0","chunk-0ea9f7ca":"f564e25f","chunk-6d9f3c4e":"33cb5906","chunk-957ac556":"82192025","chunk-2d222d54":"31d6cfe0","chunk-135a9505":"c2c93ff0","chunk-2095165e":"c603fb3b","chunk-5c68481d":"9eb23629","chunk-038fb254":"0fb97704","chunk-045fe954":"a46e23bb","chunk-06b1b3b9":"928c54da","chunk-095f4968":"e33d2cf8","chunk-0aa0fd70":"73d90fa1","chunk-0ae13ccf":"1a83b817","chunk-100ead2e":"9938b6a4","chunk-1333226f":"be5f8bfd","chunk-15a62f28":"9938b6a4","chunk-1f6fc138":"9938b6a4","chunk-282b536d":"60d5db4e","chunk-36c80a1f":"60d5db4e","chunk-3c7b5ce9":"e620d030","chunk-498486e6":"9938b6a4","chunk-5303f97e":"a088de61","chunk-552209c0":"9938b6a4","chunk-5f4b3ae3":"9938b6a4","chunk-61cd75f4":"e2d10bcb","chunk-682a9cfa":"92518bc6","chunk-6e688752":"9938b6a4","chunk-74beec90":"9938b6a4","chunk-77bb7670":"9938b6a4","chunk-7d3cf846":"dd8e9679","chunk-abb7f264":"bb0c0909","chunk-b4adb4f4":"9e52011f","chunk-cb5f09ae":"9938b6a4","chunk-2d0aa22f":"31d6cfe0","chunk-2d0b9be6":"31d6cfe0","chunk-2d0c02a4":"31d6cfe0","chunk-2d0ab69a":"31d6cfe0","chunk-2d0ac018":"31d6cfe0","chunk-2d0b366d":"31d6cfe0","chunk-2d0ced72":"31d6cfe0","chunk-2d0efd59":"31d6cfe0","chunk-2d2134cc":"31d6cfe0","chunk-2d21e30b":"31d6cfe0","chunk-2d21f458":"31d6cfe0","chunk-50e147be":"e6c762fe","chunk-afa7715a":"6541c54c","chunk-52f8f587":"7c643a41","chunk-3727a89c":"07d6d91d","chunk-2dc50050":"e808377b","chunk-4a5f46a6":"31d6cfe0","chunk-276585a0":"e6c8b5ff","chunk-05c826c2":"853a4deb","chunk-3b33b664":"ba316f0b","chunk-458f0b7f":"9a3e163d","chunk-2d22496f":"31d6cfe0","chunk-2d228fe9":"31d6cfe0","chunk-a2f8e1e0":"e92a483e","chunk-159ac50e":"d1b46603","chunk-2bdd083c":"95a13d4d","chunk-4e66891c":"c39c8984","chunk-765f3329":"2e9ce60e","chunk-e9a18b28":"13050f19","lang-de":"31d6cfe0","lang-dk":"31d6cfe0","lang-es":"31d6cfe0","lang-fr":"31d6cfe0","lang-no":"31d6cfe0","lang-se":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
